export default __webpack_public_path__ + "static/media/representatives_icon.335717d4.png";